import {
  registerMixpanelSuperProperties,
  unregisterMixpanelSuperProperty,
} from "@/modules/shared/utils/mixpanel";
import {
  registerPostHogSuperProperties,
  unregisterPostHogSuperProperty,
} from "@/modules/shared/utils/posthog";
import { EntryPoint } from "@/modules/tracking/consts/EntryPoints";

export type BookingSuperProperties = {
  entry_point: EntryPoint;
  customer_id?: number;
};

export function registerSuperProperties(
  properties: BookingSuperProperties,
): void {
  registerMixpanelSuperProperties(properties);
  registerPostHogSuperProperties(properties);
}

// Clear from both SDKs to avoid an earlier identified visit's value
// persisting (via localStorage) into a later anonymous visit on the same browser.
export function unregisterSuperProperty(
  property: keyof BookingSuperProperties,
): void {
  unregisterMixpanelSuperProperty(property);
  unregisterPostHogSuperProperty(property);
}
